import { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router';

import type { SpaceTypeEnum } from 'src/common/external/bambi-api/bambiApi';

export const usePreloadedMetadataValues = ({
  setOpen,
}: {
  setOpen: (value: boolean) => void;
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const payerId = searchParams.get('payerId');
  const spaceType = searchParams.get('spaceType');
  const tripDate = searchParams.get('tripDate');

  const preloadedMetadataValues = useMemo(() => {
    if (!payerId || !spaceType || !tripDate) {
      return undefined;
    }

    return { payerId, spaceType: spaceType as SpaceTypeEnum, tripDate };
  }, [payerId, spaceType, tripDate]);

  const handleSetOpen = (value: boolean) => {
    if (!value && (payerId || spaceType || tripDate)) {
      // clear the search params if the user closes the modal
      // so on subsequent opens, the user is not pre-filled with the same values
      setSearchParams({}, { replace: true });
    }
    setOpen(value);
  };

  useEffect(() => {
    if (payerId && spaceType && tripDate) {
      setOpen(true);
    }
  }, [payerId, spaceType, tripDate, setOpen]);

  return { preloadedMetadataValues, handleSetOpen };
};
